"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _SiteSettings = _interopRequireDefault(require("settings-ui-sdk/SiteSettings/SiteSettings"));

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _selectors = require("settings-ui-sdk/SiteSettings/selectors");

var _RequestStatusTypes = _interopRequireWildcard(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _SettingsStickySaveFooter = _interopRequireDefault(require("settings-ui-lib/components/SettingsStickySaveFooter"));

var _ContentMembershipSettingsHeaderContainer = _interopRequireDefault(require("./ContentMembershipSettingsHeaderContainer"));

var _routeSelectors = require("../selectors/routeSelectors");

var didSiteSettingsFromRouteChange = function didSiteSettingsFromRouteChange(currentSiteSettings, nextSiteSettings) {
  return nextSiteSettings !== undefined && nextSiteSettings.get(_constants.ALL_DOMAINS_OR_DOMAIN_NAME) !== currentSiteSettings.get(_constants.ALL_DOMAINS_OR_DOMAIN_NAME);
};

var didSiteSettingsSuccessfullyUpdate = function didSiteSettingsSuccessfullyUpdate(currentRequestStatus, nextRequestStatus) {
  return currentRequestStatus === _RequestStatusTypes.default.PENDING && nextRequestStatus === _RequestStatusTypes.default.SUCCEEDED;
};

var ContentMembershipSettingsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ContentMembershipSettingsContainer, _PureComponent);

  function ContentMembershipSettingsContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContentMembershipSettingsContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContentMembershipSettingsContainer).call(this, props));
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this)); // Prevent savebar from rendering on page load.

    _this.state = {
      hideSavebar: true
    };
    return _this;
  }

  (0, _createClass2.default)(ContentMembershipSettingsContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var siteSettingsFromRoute = this.props.siteSettingsFromRoute;
      this.props.stageForEdit(siteSettingsFromRoute);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this.setState({
        hideSavebar: false
      });
      var _this$props = this.props,
          siteSettingsFromRoute = _this$props.siteSettingsFromRoute,
          saveSiteSettingsChangesRequestStatus = _this$props.saveSiteSettingsChangesRequestStatus;

      if (didSiteSettingsFromRouteChange(siteSettingsFromRoute, newProps.siteSettingsFromRoute) || didSiteSettingsSuccessfullyUpdate(saveSiteSettingsChangesRequestStatus, newProps.saveSiteSettingsChangesRequestStatus)) {
        this.props.stageForEdit(newProps.siteSettingsFromRoute);
      }
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var siteSettingsForSaving = this.props.siteSettingsForSaving;

      var _siteSettingsForSavin = siteSettingsForSaving.toJS(),
          allDomainsOrDomainName = _siteSettingsForSavin.allDomainsOrDomainName,
          settingsToSave = (0, _objectWithoutProperties2.default)(_siteSettingsForSavin, ["allDomainsOrDomainName"]);

      this.props.saveStagedSiteSettingsChanges(settingsToSave, {
        selectedDomain: allDomainsOrDomainName
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          saveSiteSettingsChangesRequestStatus = _this$props2.saveSiteSettingsChangesRequestStatus,
          anyInvalidStagedChanges = _this$props2.anyInvalidStagedChanges,
          validationMessage = _this$props2.validationMessage,
          numberOfStagedChanges = _this$props2.numberOfStagedChanges;
      var hideSavebar = this.state.hideSavebar;
      var showStickySaveBar = numberOfStagedChanges > 0 && !hideSavebar;
      var description;

      if (anyInvalidStagedChanges) {
        description = validationMessage;
      } else if (numberOfStagedChanges === 1) {
        description = _I18n.default.text('marketing.pages.stagedChange');
      } else if (numberOfStagedChanges > 1) {
        description = (0, _unescapedText.default)('marketing.pages.stagedChanges', {
          numberOfStagedChanges: numberOfStagedChanges
        });
      }

      return _react.default.createElement("div", null, _react.default.createElement(_ContentMembershipSettingsHeaderContainer.default, null), children, _react.default.createElement(_SettingsStickySaveFooter.default, {
        saveRequestStatus: saveSiteSettingsChangesRequestStatus,
        shouldRender: showStickySaveBar,
        description: description,
        saveDisabled: anyInvalidStagedChanges,
        onCancel: this.props.resetChanges,
        onSave: this.handleSave
      }));
    }
  }]);
  return ContentMembershipSettingsContainer;
}(_react.PureComponent);

ContentMembershipSettingsContainer.propTypes = {
  children: _react.PropTypes.node.isRequired,
  anyInvalidStagedChanges: _react.PropTypes.bool,
  siteSettingsFromRoute: _react.PropTypes.instanceOf(_SiteSettings.default).isRequired,
  siteSettingsForSaving: _react.PropTypes.object.isRequired,
  saveStagedSiteSettingsChanges: _react.PropTypes.func.isRequired,
  saveSiteSettingsChangesRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  numberOfStagedChanges: _react.PropTypes.number.isRequired,
  validationMessage: _react.PropTypes.node,
  stageForEdit: _react.PropTypes.func.isRequired,
  resetChanges: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    siteSettingsFromRoute: (0, _routeSelectors.getSiteSettingsFromRoute)(state),
    saveSiteSettingsChangesRequestStatus: (0, _selectors.getSaveSiteSettingsChangesRequestStatus)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  saveStagedSiteSettingsChanges: _actions.saveStagedSiteSettingsChanges
})(ContentMembershipSettingsContainer);

exports.default = _default;
module.exports = exports.default;